exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "ul,\ndiv .vacancy-text {\n  white-space: pre-wrap;\n}\n\n", ""]);

// exports
